export default __webpack_public_path__ + "static/contact-3476662ccdb092d5cbae377a96f1a987.jpg";